var map = {
	"./ion-action-sheet-controller_8.entry.js": [
		42473,
		"common",
		"node_modules_ionic_core_dist_esm_ion-action-sheet-controller_8_entry_js"
	],
	"./ion-action-sheet-ios.entry.js": [
		56616,
		"common",
		"node_modules_ionic_core_dist_esm_ion-action-sheet-ios_entry_js"
	],
	"./ion-action-sheet-md.entry.js": [
		45152,
		"common",
		"node_modules_ionic_core_dist_esm_ion-action-sheet-md_entry_js"
	],
	"./ion-alert-ios.entry.js": [
		89460,
		"common",
		"node_modules_ionic_core_dist_esm_ion-alert-ios_entry_js"
	],
	"./ion-alert-md.entry.js": [
		85991,
		"common",
		"node_modules_ionic_core_dist_esm_ion-alert-md_entry_js"
	],
	"./ion-app_8-ios.entry.js": [
		88545,
		"common",
		"node_modules_ionic_core_dist_esm_ion-app_8-ios_entry_js"
	],
	"./ion-app_8-md.entry.js": [
		33533,
		"common",
		"node_modules_ionic_core_dist_esm_ion-app_8-md_entry_js"
	],
	"./ion-avatar_3-ios.entry.js": [
		23972,
		"common",
		"node_modules_ionic_core_dist_esm_ion-avatar_3-ios_entry_js"
	],
	"./ion-avatar_3-md.entry.js": [
		21093,
		"common",
		"node_modules_ionic_core_dist_esm_ion-avatar_3-md_entry_js"
	],
	"./ion-back-button-ios.entry.js": [
		78590,
		"common",
		"node_modules_ionic_core_dist_esm_ion-back-button-ios_entry_js"
	],
	"./ion-back-button-md.entry.js": [
		52887,
		"common",
		"node_modules_ionic_core_dist_esm_ion-back-button-md_entry_js"
	],
	"./ion-backdrop-ios.entry.js": [
		29507,
		"node_modules_ionic_core_dist_esm_ion-backdrop-ios_entry_js"
	],
	"./ion-backdrop-md.entry.js": [
		79146,
		"node_modules_ionic_core_dist_esm_ion-backdrop-md_entry_js"
	],
	"./ion-button_2-ios.entry.js": [
		78789,
		"common",
		"node_modules_ionic_core_dist_esm_ion-button_2-ios_entry_js"
	],
	"./ion-button_2-md.entry.js": [
		81678,
		"common",
		"node_modules_ionic_core_dist_esm_ion-button_2-md_entry_js"
	],
	"./ion-card_5-ios.entry.js": [
		27538,
		"common",
		"node_modules_ionic_core_dist_esm_ion-card_5-ios_entry_js"
	],
	"./ion-card_5-md.entry.js": [
		74694,
		"common",
		"node_modules_ionic_core_dist_esm_ion-card_5-md_entry_js"
	],
	"./ion-checkbox-ios.entry.js": [
		63682,
		"common",
		"node_modules_ionic_core_dist_esm_ion-checkbox-ios_entry_js"
	],
	"./ion-checkbox-md.entry.js": [
		24303,
		"common",
		"node_modules_ionic_core_dist_esm_ion-checkbox-md_entry_js"
	],
	"./ion-chip-ios.entry.js": [
		51962,
		"common",
		"node_modules_ionic_core_dist_esm_ion-chip-ios_entry_js"
	],
	"./ion-chip-md.entry.js": [
		34966,
		"common",
		"node_modules_ionic_core_dist_esm_ion-chip-md_entry_js"
	],
	"./ion-col_3.entry.js": [
		16034,
		"node_modules_ionic_core_dist_esm_ion-col_3_entry_js"
	],
	"./ion-datetime_3-ios.entry.js": [
		2803,
		"common",
		"node_modules_ionic_core_dist_esm_ion-datetime_3-ios_entry_js"
	],
	"./ion-datetime_3-md.entry.js": [
		57202,
		"common",
		"node_modules_ionic_core_dist_esm_ion-datetime_3-md_entry_js"
	],
	"./ion-fab_3-ios.entry.js": [
		35001,
		"common",
		"node_modules_ionic_core_dist_esm_ion-fab_3-ios_entry_js"
	],
	"./ion-fab_3-md.entry.js": [
		28563,
		"common",
		"node_modules_ionic_core_dist_esm_ion-fab_3-md_entry_js"
	],
	"./ion-img.entry.js": [
		41709,
		"node_modules_ionic_core_dist_esm_ion-img_entry_js"
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		21629,
		"common",
		"node_modules_ionic_core_dist_esm_ion-infinite-scroll_2-ios_entry_js"
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		45534,
		"common",
		"node_modules_ionic_core_dist_esm_ion-infinite-scroll_2-md_entry_js"
	],
	"./ion-input-ios.entry.js": [
		15430,
		"common",
		"node_modules_ionic_core_dist_esm_ion-input-ios_entry_js"
	],
	"./ion-input-md.entry.js": [
		81005,
		"common",
		"node_modules_ionic_core_dist_esm_ion-input-md_entry_js"
	],
	"./ion-item-option_3-ios.entry.js": [
		5833,
		"common",
		"node_modules_ionic_core_dist_esm_ion-item-option_3-ios_entry_js"
	],
	"./ion-item-option_3-md.entry.js": [
		73809,
		"common",
		"node_modules_ionic_core_dist_esm_ion-item-option_3-md_entry_js"
	],
	"./ion-item_8-ios.entry.js": [
		22918,
		"common",
		"node_modules_ionic_core_dist_esm_ion-item_8-ios_entry_js"
	],
	"./ion-item_8-md.entry.js": [
		79939,
		"common",
		"node_modules_ionic_core_dist_esm_ion-item_8-md_entry_js"
	],
	"./ion-loading-ios.entry.js": [
		55290,
		"common",
		"node_modules_ionic_core_dist_esm_ion-loading-ios_entry_js"
	],
	"./ion-loading-md.entry.js": [
		64794,
		"common",
		"node_modules_ionic_core_dist_esm_ion-loading-md_entry_js"
	],
	"./ion-menu_4-ios.entry.js": [
		18271,
		"common",
		"node_modules_ionic_core_dist_esm_ion-menu_4-ios_entry_js"
	],
	"./ion-menu_4-md.entry.js": [
		67816,
		"common",
		"node_modules_ionic_core_dist_esm_ion-menu_4-md_entry_js"
	],
	"./ion-modal-ios.entry.js": [
		13949,
		"common",
		"node_modules_ionic_core_dist_esm_ion-modal-ios_entry_js"
	],
	"./ion-modal-md.entry.js": [
		62707,
		"common",
		"node_modules_ionic_core_dist_esm_ion-modal-md_entry_js"
	],
	"./ion-nav_5.entry.js": [
		49246,
		"common",
		"node_modules_ionic_core_dist_esm_ion-nav_5_entry_js"
	],
	"./ion-popover-ios.entry.js": [
		40636,
		"common",
		"node_modules_ionic_core_dist_esm_ion-popover-ios_entry_js"
	],
	"./ion-popover-md.entry.js": [
		79676,
		"common",
		"node_modules_ionic_core_dist_esm_ion-popover-md_entry_js"
	],
	"./ion-progress-bar-ios.entry.js": [
		32063,
		"common",
		"node_modules_ionic_core_dist_esm_ion-progress-bar-ios_entry_js"
	],
	"./ion-progress-bar-md.entry.js": [
		45766,
		"common",
		"node_modules_ionic_core_dist_esm_ion-progress-bar-md_entry_js"
	],
	"./ion-radio_2-ios.entry.js": [
		12664,
		"common",
		"node_modules_ionic_core_dist_esm_ion-radio_2-ios_entry_js"
	],
	"./ion-radio_2-md.entry.js": [
		7283,
		"common",
		"node_modules_ionic_core_dist_esm_ion-radio_2-md_entry_js"
	],
	"./ion-range-ios.entry.js": [
		85768,
		"common",
		"node_modules_ionic_core_dist_esm_ion-range-ios_entry_js"
	],
	"./ion-range-md.entry.js": [
		47763,
		"common",
		"node_modules_ionic_core_dist_esm_ion-range-md_entry_js"
	],
	"./ion-refresher_2-ios.entry.js": [
		84831,
		"common",
		"node_modules_ionic_core_dist_esm_ion-refresher_2-ios_entry_js"
	],
	"./ion-refresher_2-md.entry.js": [
		61530,
		"common",
		"node_modules_ionic_core_dist_esm_ion-refresher_2-md_entry_js"
	],
	"./ion-reorder_2-ios.entry.js": [
		17266,
		"common",
		"node_modules_ionic_core_dist_esm_ion-reorder_2-ios_entry_js"
	],
	"./ion-reorder_2-md.entry.js": [
		3872,
		"common",
		"node_modules_ionic_core_dist_esm_ion-reorder_2-md_entry_js"
	],
	"./ion-ripple-effect.entry.js": [
		51602,
		"node_modules_ionic_core_dist_esm_ion-ripple-effect_entry_js"
	],
	"./ion-route_4.entry.js": [
		45174,
		"common",
		"node_modules_ionic_core_dist_esm_ion-route_4_entry_js"
	],
	"./ion-searchbar-ios.entry.js": [
		89128,
		"common",
		"node_modules_ionic_core_dist_esm_ion-searchbar-ios_entry_js"
	],
	"./ion-searchbar-md.entry.js": [
		84857,
		"common",
		"node_modules_ionic_core_dist_esm_ion-searchbar-md_entry_js"
	],
	"./ion-segment_2-ios.entry.js": [
		47768,
		"common",
		"node_modules_ionic_core_dist_esm_ion-segment_2-ios_entry_js"
	],
	"./ion-segment_2-md.entry.js": [
		44807,
		"common",
		"node_modules_ionic_core_dist_esm_ion-segment_2-md_entry_js"
	],
	"./ion-select_3-ios.entry.js": [
		19705,
		"common",
		"node_modules_ionic_core_dist_esm_ion-select_3-ios_entry_js"
	],
	"./ion-select_3-md.entry.js": [
		87345,
		"common",
		"node_modules_ionic_core_dist_esm_ion-select_3-md_entry_js"
	],
	"./ion-slide_2-ios.entry.js": [
		87545,
		"node_modules_ionic_core_dist_esm_ion-slide_2-ios_entry_js"
	],
	"./ion-slide_2-md.entry.js": [
		41556,
		"node_modules_ionic_core_dist_esm_ion-slide_2-md_entry_js"
	],
	"./ion-spinner.entry.js": [
		81374,
		"common",
		"node_modules_ionic_core_dist_esm_ion-spinner_entry_js"
	],
	"./ion-split-pane-ios.entry.js": [
		24206,
		"node_modules_ionic_core_dist_esm_ion-split-pane-ios_entry_js"
	],
	"./ion-split-pane-md.entry.js": [
		13583,
		"node_modules_ionic_core_dist_esm_ion-split-pane-md_entry_js"
	],
	"./ion-tab-bar_2-ios.entry.js": [
		41933,
		"common",
		"node_modules_ionic_core_dist_esm_ion-tab-bar_2-ios_entry_js"
	],
	"./ion-tab-bar_2-md.entry.js": [
		89592,
		"common",
		"node_modules_ionic_core_dist_esm_ion-tab-bar_2-md_entry_js"
	],
	"./ion-tab_2.entry.js": [
		77802,
		"common",
		"node_modules_ionic_core_dist_esm_ion-tab_2_entry_js"
	],
	"./ion-text.entry.js": [
		29072,
		"common",
		"node_modules_ionic_core_dist_esm_ion-text_entry_js"
	],
	"./ion-textarea-ios.entry.js": [
		88829,
		"common",
		"node_modules_ionic_core_dist_esm_ion-textarea-ios_entry_js"
	],
	"./ion-textarea-md.entry.js": [
		87546,
		"common",
		"node_modules_ionic_core_dist_esm_ion-textarea-md_entry_js"
	],
	"./ion-toast-ios.entry.js": [
		16307,
		"common",
		"node_modules_ionic_core_dist_esm_ion-toast-ios_entry_js"
	],
	"./ion-toast-md.entry.js": [
		32508,
		"common",
		"node_modules_ionic_core_dist_esm_ion-toast-md_entry_js"
	],
	"./ion-toggle-ios.entry.js": [
		65066,
		"common",
		"node_modules_ionic_core_dist_esm_ion-toggle-ios_entry_js"
	],
	"./ion-toggle-md.entry.js": [
		14732,
		"common",
		"node_modules_ionic_core_dist_esm_ion-toggle-md_entry_js"
	],
	"./ion-virtual-scroll.entry.js": [
		10431,
		"node_modules_ionic_core_dist_esm_ion-virtual-scroll_entry_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 50863;
module.exports = webpackAsyncContext;